// extracted by mini-css-extract-plugin
export default {"base":"vp_LKvCK","dot":"vp_lnXVG","high":"vp_PoXmY","isOn":"vp_fGAXG","count":"vp_Lz7X4","mid":"vp_nl7Ku","low":"vp_Vpab1"};